export default __webpack_public_path__ + "static/stake_pool-b9c4a2a4f913451516aec4739fd4ded7.png";